import { Link, useNavigate } from "react-router-dom";
import { Page } from "../../components/page/page";
import { useUser } from "../../hooks/use-user/useUser";
import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { NavList } from "../../components/nav-list/navList";
import { Logout } from "../../components/logout/logout";

export const Admin: React.FC = () => {
  const { user } = useUser();
  const { localize } = useLocalization();
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  return (
    <Page title={user.name || user.email}>
      <NavList
        items={[
          {
            to: "navn",
            label: localize("admin:name"),
            icon: (
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10 3.9C10.2758 3.9 10.5489 3.95432 10.8036 4.05985C11.0584 4.16539 11.2899 4.32007 11.4849 4.51508C11.6799 4.71008 11.8346 4.94158 11.9401 5.19637C12.0457 5.45115 12.1 5.72422 12.1 6C12.1 6.27578 12.0457 6.54885 11.9401 6.80364C11.8346 7.05842 11.6799 7.28992 11.4849 7.48492C11.2899 7.67993 11.0584 7.83461 10.8036 7.94015C10.5489 8.04568 10.2758 8.1 10 8.1C9.44305 8.1 8.9089 7.87875 8.51508 7.48492C8.12125 7.0911 7.9 6.55695 7.9 6C7.9 5.44305 8.12125 4.9089 8.51508 4.51508C8.9089 4.12125 9.44305 3.9 10 3.9ZM10 12.9C12.97 12.9 16.1 14.36 16.1 15V16.1H3.9V15C3.9 14.36 7.03 12.9 10 12.9ZM10 2C7.79 2 6 3.79 6 6C6 8.21 7.79 10 10 10C12.21 10 14 8.21 14 6C14 3.79 12.21 2 10 2ZM10 11C7.33 11 2 12.34 2 15V17C2 17.55 2.45 18 3 18H17C17.55 18 18 17.55 18 17V15C18 12.34 12.67 11 10 11Z" />
              </svg>
            ),
          },
          {
            to: "e-post",
            label: localize("email"),
            icon: (
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M18 5.81152C18 4.98652 17.28 4.31152 16.4 4.31152H3.6C2.72 4.31152 2 4.98652 2 5.81152V14.8115C2 15.6365 2.72 16.3115 3.6 16.3115H16.4C17.28 16.3115 18 15.6365 18 14.8115V5.81152ZM16.4 5.81152L10 9.56152L3.6 5.81152H16.4ZM16.4 14.8115H3.6V7.31152L10 11.0615L16.4 7.31152V14.8115Z" />
              </svg>
            ),
          },
          {
            to: "telefonnummer",
            label: localize("phone"),
            icon: (
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5.45 4.47819C5.5 5.21986 5.625 5.94486 5.825 6.63652L4.825 7.63652C4.48333 6.63652 4.26667 5.57819 4.19167 4.47819H5.45ZM13.6667 14.4949C14.375 14.6949 15.1 14.8199 15.8333 14.8699V16.1115C14.7333 16.0365 13.675 15.8199 12.6667 15.4865L13.6667 14.4949ZM6.25 2.81152H3.33333C2.875 2.81152 2.5 3.18652 2.5 3.64486C2.5 11.4699 8.84167 17.8115 16.6667 17.8115C17.125 17.8115 17.5 17.4365 17.5 16.9782V14.0699C17.5 13.6115 17.125 13.2365 16.6667 13.2365C15.6333 13.2365 14.625 13.0699 13.6917 12.7615C13.6092 12.7307 13.5214 12.7165 13.4333 12.7199C13.2167 12.7199 13.0083 12.8032 12.8417 12.9615L11.0083 14.7949C8.64622 13.5868 6.72472 11.6653 5.51667 9.30319L7.35 7.46986C7.58333 7.23652 7.65 6.91152 7.55833 6.61986C7.24277 5.65977 7.08242 4.65548 7.08333 3.64486C7.08333 3.18652 6.70833 2.81152 6.25 2.81152Z" />
              </svg>
            ),
          },
          {
            to: "endre-passord",
            label: localize("admin:changePassword"),
            icon: (
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M15.25 7.31152H14.375V5.59724C14.375 3.23152 12.415 1.31152 10 1.31152C7.585 1.31152 5.625 3.23152 5.625 5.59724V7.31152H4.75C3.7875 7.31152 3 8.08295 3 9.02581V17.5972C3 18.5401 3.7875 19.3115 4.75 19.3115H15.25C16.2125 19.3115 17 18.5401 17 17.5972V9.02581C17 8.08295 16.2125 7.31152 15.25 7.31152ZM7.375 5.59724C7.375 4.17438 8.5475 3.02581 10 3.02581C11.4525 3.02581 12.625 4.17438 12.625 5.59724V7.31152H7.375V5.59724ZM15.25 17.5972H4.75V9.02581H15.25V17.5972ZM10 15.0258C10.9625 15.0258 11.75 14.2544 11.75 13.3115C11.75 12.3687 10.9625 11.5972 10 11.5972C9.0375 11.5972 8.25 12.3687 8.25 13.3115C8.25 14.2544 9.0375 15.0258 10 15.0258Z" />
              </svg>
            ),
          },
          {
            to: "tofaktor",
            label: localize("otp:title"),
            icon: (
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10 2.31152L3 4.71152V9.58352C3 13.6235 5.98375 17.3915 10 18.3115C14.0163 17.3915 17 13.6235 17 9.58352V4.71152L10 2.31152ZM15.25 9.58352C15.25 12.7835 13.0188 15.7435 10 16.6475C6.98125 15.7435 4.75 12.7915 4.75 9.58352V5.82352L10 4.02352L15.25 5.82352V9.58352Z" />
              </svg>
            ),
          },
        ]}
      />
      <Logout onLogout={() => navigate("../logg-inn", { relative: "path" })} />
      <Link to="../" relative="path" className="button">
        {localize("back")}
      </Link>
    </Page>
  );
};
